<template>
  <div class="mt-6">
    <div class="p-6 rounded-xl">
      <div class="relative text-center">
        <div class="flex justify-center mb-6">
          <div class="relative">
            <div class="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center">
              <span class="text-4xl">🏆</span>
            </div>
          </div>
        </div>

        <h2 class="text-3xl font-bold text-gray-900 mb-2">Félicitations !</h2>
        <p class="text-base text-gray-600 mb-8">Vous avez réalisé une vente avec succès 🎉</p>

        <div class="bg-green-50 rounded-xl p-6 mb-6">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-4">
              <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <span class="text-2xl">💰</span>
              </div>
              <div class="text-left">
                <p class="text-sm text-gray-700 mb-1">Prime gagnée</p>
                <p class="text-2xl font-bold text-gray-900">
                  {{ formattedRewardAmount }}
                </p>
              </div>
            </div>
            <div v-if="!isSepaPayment" class="flex items-center gap-2">
              <div class="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                <CheckIcon class="w-4 h-4 text-white" />
              </div>
              <span class="text-sm font-medium text-green-600">Acquis</span>
            </div>
          </div>
        </div>

        <div v-if="isSepaPayment" class="mt-4 rounded-lg bg-gray-100 p-4 text-center">
          <p class="text-sm text-gray-700 text-center">
            Cette vente a été réalisée avec un paiement par prélèvement SEPA.
            <br />
            La prime sera
            <span class="font-semibold">visible dans le suivi des primes</span>
            une fois
            <span class="font-semibold">le paiement confirmé.</span>
          </p>
        </div>
        <div v-else class="mt-4">
          <router-link
            to="/pos/retributions"
            class="text-gray-500 hover:text-primary-dark underline text-sm font-light"
          >
            Voir le détail des primes
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckIcon } from "@heroicons/vue/outline";
import { formatPrice } from "@estaly/ui";

export default {
  components: {
    CheckIcon,
  },

  props: {
    rewardAmount: {
      type: Number,
      required: true,
    },
    isSepaPayment: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    formattedRewardAmount() {
      return `+${formatPrice(this.rewardAmount)}`;
    },
  },
};
</script>
